import React from 'react';
import { prop } from 'js/utils/ramda.util';
import StretchText from 'js/components/common/StretchText';
import { usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';

import style from './index.scss';

export default () => {
    const t = usePortletTranslations();
    const INDENT = 0.1;
    const { convert, total, ...balances } = usePortletSelector(prop('balances'));
    const products = Object.keys(balances);

    return <div className={style.header}>
        <div className={style.balance}>
            <StretchText indent={INDENT} className={style.amount}>{convert}</StretchText>
            <div className={style.text}>
                {t('accumulatedPoints')}
            </div>
            {Boolean(products.length) && (
                <ul className={style.points}>
                    {products.map((product) => (
                        <li key={product} className={style.row}>
                            <span className={style.name}>{t(`${product}`)}</span>
                            <span className={style.value}>{balances[product]} {t('units')}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
        <div className={style.balance}>
            <StretchText indent={INDENT} className={style.amount}>{total}</StretchText>
            <div className={style.text}>
                {t('totalPoints')}
            </div>
        </div>
    </div>;
};
